import { lazy, type ComponentType } from "react";

/**
 * Lusta betöltés újrapróbálással. A leggyakoribb ok, hogy közben új verziót telepítettünk, és a
 * régi oldalon lévő darab (chunk) neve már nem létezik: ilyenkor egyszer újratöltjük az oldalt.
 */
const RELOADED = "propsys.chunkReload";

export function lazyWithRetry<T extends ComponentType<unknown>>(load: () => Promise<{ default: T }>) {
  return lazy(async () => {
    try {
      const mod = await load();
      sessionStorage.removeItem(RELOADED);
      return mod;
    } catch (err) {
      // Egy gyors újrapróbálás pillanatnyi hálózati hibára.
      try {
        await new Promise((r) => setTimeout(r, 600));
        return await load();
      } catch {
        // Új verzió: egyszer frissítünk (végtelen kör elkerülésével).
        if (sessionStorage.getItem(RELOADED) !== "1") {
          sessionStorage.setItem(RELOADED, "1");
          window.location.reload();
          return new Promise<{ default: T }>(() => {});
        }
        throw err;
      }
    }
  });
}
